export default __webpack_public_path__ + "static/media/noPermision.6c782b59.png";